/* 全局: 抽屉菜单 + 购物车抽屉(Ajax Cart API) */
(function () {
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- 菜单抽屉 ---- */
  var menuDrawer = qs('[data-aa-menu-drawer]');
  if (menuDrawer) {
    qsa('[data-aa-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { menuDrawer.classList.add('open'); });
    });
    qsa('[data-aa-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { menuDrawer.classList.remove('open'); });
    });
  }

  /* ---- 购物车抽屉 ---- */
  var cartDrawer = qs('[data-aa-cart-drawer]');
  if (!cartDrawer) return;
  var cartBody = qs('[data-aa-cart-body]');
  var cartFoot = qs('[data-aa-cart-foot]');
  var cartCount = qs('[data-aa-cart-count]');
  var cartSubtotal = qs('[data-aa-cart-subtotal]');
  var moneyFmt = '{{ shop.money_format | default: "${{amount}}" }}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace('$${amount}', '$' + amount);
  }
  function openCart() { cartDrawer.classList.add('open'); }
  function closeCart() { cartDrawer.classList.remove('open'); }
  qsa('[data-aa-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
  qsa('[data-aa-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });

  function renderCart(cart) {
    cartCount.textContent = cart.item_count;
    if (!cart.items.length) {
      cartBody.innerHTML = '<p class="aa-cart__empty">No products in the cart.</p>';
      cartFoot.style.display = 'none';
      return;
    }
    cartFoot.style.display = '';
    cartSubtotal.textContent = formatMoney(cart.total_price);
    cartBody.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_120x$1') + '" alt="">' : '';
      return '<div class="aa-cart__item">' + img +
        '<div class="aa-cart__item-info">' +
        '<a href="' + item.url + '" class="aa-cart__item-title">' + item.product_title + '</a>' +
        '<div class="aa-cart__item-qty">' + item.quantity + ' × ' + formatMoney(item.final_price) + '</div>' +
        '<button class="aa-cart__item-remove" data-line="' + item.key + '">remove</button>' +
        '</div></div>';
    }).join('');
    qsa('.aa-cart__item-remove', cartBody).forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.getAttribute('data-line'), quantity: 0 })
        }).then(function (r) { return r.json(); }).then(renderCart);
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  /* 拦截 add-to-cart 表单 → Ajax 加入并弹抽屉 */
  qsa('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)).toString()
      }).then(refreshCart).then(openCart);
    });
  });

  refreshCart();
})();
